import { Component, OnInit, Input, Output } from "@angular/core";
import { Device } from "../../devices.model_new";
import {
  DeviceTypesMap,
  DeviceType,
  CONNECTIVITY_STATE,
  STATE_VAR,
  GROUP,
} from "../../devices.constant";
import { SharedUtils } from "../../../../shared/shared.utils";
import { Router } from "@angular/router";
import { IotService } from "../../../../core/services/iot.service";
import { EventEmitter } from "events";
import { Schedule } from "../../../scheduling/scheduling.model";
import { SchedulingUtils } from "../../../scheduling/shedulling.utils";
import { GeneralService } from "../../../../shared/services/general.service";

@Component({
  selector: "app-device-card",
  templateUrl: "./device-card.component.html",
  styleUrls: ["./device-card.component.scss"],
})
export class DeviceCardComponent implements OnInit {
  @Input()
  device: Device;
  @Input()
  type: string;
  @Input()
  subType: string;
  @Input()
  schedules: Schedule[];

  @Output() switched = new EventEmitter();

  properties;

  SharedUtils = SharedUtils;
  CONNECTIVITY_STATE = CONNECTIVITY_STATE;
  STATE_VAR = STATE_VAR;
  visible;

  constructor(
    private router: Router,
    private iotService: IotService,
    private generalService: GeneralService
  ) {}

  ngOnInit() {
    const deviceType = DeviceTypesMap.map.get(<DeviceType>this.type);
    if (deviceType.subTypes) {
      this.properties = deviceType.subTypes.map.get(this.subType).properties;
    } else {
      this.properties = deviceType.properties;
    }
  }

  getLoading(): boolean {
    return this.iotService.isUpdatingModule(this.device.getModuleLocalId());
  }

  getDeviceProperty(property: string): any {
    return this.properties[property];
  }

  isIconOffLetters(): boolean {
    return this.device.isStateVarSupported(STATE_VAR.RELAY_STATE)
      ? !this.device.getStateVar(STATE_VAR.RELAY_STATE).value ||
          this.device.isConnectivityStateOffline()
      : this.device.isConnectivityStateOffline();
  }

  hasPower(): boolean {
    return (
      (this.device.isStateVarSupported(STATE_VAR.ACTIVE_POWER_A_PLUS) ||
        this.device.isStateVarSupported(STATE_VAR.ACTIVE_POWER_A_MINUS)) &&
      (this.device.isStateVarSupported(STATE_VAR.RELAY_STATE)
        ? this.device.getStateVar(STATE_VAR.RELAY_STATE).value
        : true) &&
      this.device.isConnectivityStateOnline()
    );
  }

  hasTemperature(): boolean {
    return (
      (this.device.isConnectivityStateOnline() ||
        this.device.isConnectivityStateSleeping()) &&
      (this.device.isStateVarSupported(STATE_VAR.TEMPERATURE) ||
        (this.device.isStateVarSupported(STATE_VAR.PROCESS_TEMP) &&
          this.device.getStateVar(STATE_VAR.SETPOINT) !== 7) ||
        this.device.isStateVarSupported(STATE_VAR.SETPOINT))
    );
  }

  hasScheduling(): boolean {
    return (
      this.device.getGroups().has(GROUP.SWITCH) ||
      this.device.getGroups().has(GROUP.THERMOSTAT)
    );
  }

  getTemperatureStateVar(): any {
    if (this.device.isStateVarSupported(STATE_VAR.TEMPERATURE)) {
      return this.device.getStateVar(STATE_VAR.TEMPERATURE);
    } else if (this.device.isStateVarSupported(STATE_VAR.PROCESS_TEMP)) {
      return this.device.getStateVar(STATE_VAR.PROCESS_TEMP);
    } else if (this.device.isStateVarSupported(STATE_VAR.SETPOINT)) {
      return this.device.getStateVar(STATE_VAR.SETPOINT);
    } else {
      // console.error('Temperature not supported');
      return -1;
    }
  }

  getTemperature(): any {
    const t = SharedUtils.getEnergy(this.getTemperatureStateVar().value);
    return t !== 0 ? t.toFixed(1) : t;
  }

  getScheduleLable(): string {
    const days = SchedulingUtils.formatSchedulesForDeviceList(
      this.schedules
    ).split(" ");
    let result = "";
    days.forEach((day) => {
      if (day !== "") {
        result = result + this.generalService.translate.instant(day) + " ";
      }
    });
    return result;
  }

  isDefaultTemperature(): boolean {
    return (
      this.device.isStateVarSupported(STATE_VAR.TEMPERATURE) ||
      this.device.isStateVarSupported(STATE_VAR.PROCESS_TEMP)
    );
  }

  isHvacOff(): boolean {
    return (
      this.isConnectivityStateOffline() ||
      this.device.getStateVar(STATE_VAR.OPERATION_MODE) === "OFF"
    );
  }

  isConnectivityStateOnline(): boolean {
    return this.device.getConnectivityState() === CONNECTIVITY_STATE.ONLINE;
  }

  isConnectivityStateOffline(): boolean {
    return this.device.getConnectivityState() === CONNECTIVITY_STATE.OFFLINE;
  }

  isConnectivityStateSleeping(): boolean {
    return this.device.getConnectivityState() === CONNECTIVITY_STATE.SLEEPING;
  }

  onDetail() {
    this.router.navigate([`/devices/${this.device.getModuleId()}`]);
  }

  onSwitch(event) {
    event.stopPropagation();
    if (!this.device.getUserAttribute("locked")) {
      const stateVar = this.device.getStateVar(STATE_VAR.RELAY_STATE);
      this.iotService.updateModule(
        this.device,
        STATE_VAR.RELAY_STATE,
        !stateVar.value
      );
    }
  }
}



// WEBPACK FOOTER //
// ./src/app/entities/devices/device-tab/device-card/device-card.component.ts